import * as Linking from 'expo-linking';
import { useCallback } from 'react';
import { useToastController } from 'smoothie';

import { SUPPORT_EMAIL } from '../../settings/types/constants';

interface SendEmailToSupportOptions {
    subject?: string;
    body?: string;
    showToast?: boolean;
}

const getSupportMailtoHref = ({
    subject,
    body,
}: Pick<SendEmailToSupportOptions, 'subject' | 'body'> = {}) => {
    const query = [
        subject != null && subject !== ''
            ? `subject=${encodeURIComponent(subject)}`
            : null,
        body != null && body !== '' ? `body=${encodeURIComponent(body)}` : null,
    ].filter((part): part is string => part != null);

    if (query.length === 0) {
        return `mailto:${SUPPORT_EMAIL}`;
    }

    return `mailto:${SUPPORT_EMAIL}?${query.join('&')}`;
};

export const useSendEmailToSupport = () => {
    const toast = useToastController();

    return useCallback(
        async ({
            subject,
            body,
            showToast = true,
        }: SendEmailToSupportOptions = {}) => {
            try {
                await Linking.openURL(getSupportMailtoHref({ subject, body }));
            } catch {
                if (showToast) {
                    toast.show(
                        `Error opening email app. Contact support at ${SUPPORT_EMAIL}`,
                        { duration: 4000 },
                    );
                }
            }
        },
        [toast],
    );
};
